import { currentApyAndInterestRate, formatDollars } from '@fruitful/fruitils';
import {
    AccountAllocationCard,
    BodyLargeRegular,
    FontFamilyName,
    SuperscriptText,
    YStack,
} from 'smoothie';

import { useConversationalMMContext } from '../context/ConversationalMMContextBase';
import {
    BankingDisclosures,
    Header,
    LinearGradientBackgroundCard,
} from './shared';
import { SlideNextButton } from './SlideNextButton';

export const BillsSlide = () => {
    const { results } = useConversationalMMContext();
    const { billsTotalCents } = results.moneyMap;
    const billsFormatted = formatDollars(billsTotalCents / 100, false);

    const { formattedApy } = currentApyAndInterestRate();

    return (
        <YStack
            width="100%"
            justifyContent="center"
            alignItems="center"
            gap={24}
        >
            <LinearGradientBackgroundCard>
                <YStack
                    gap={24}
                    width="100%"
                    justifyContent="center"
                    alignItems="center"
                >
                    <Header
                        title="Bills"
                        description="Your bills, handled automatically."
                    />

                    <SuperscriptText
                        superscript={1}
                        textBefore={`Each month, ${billsFormatted} goes into your Core account to cover your fixed expenses — housing, utilities, subscriptions. It's a real, FDIC-insured bank account earning ${formattedApy} Annual Percentage Yield.`}
                        textComponent={BodyLargeRegular}
                        textProps={{
                            style: {
                                fontFamily: FontFamilyName.SourceSerifRegular,
                            },
                        }}
                    />

                    <AccountAllocationCard
                        label="Bills"
                        accountName="Core"
                        accountSubtitle="Fruitful Cash Account"
                        amountText={`${billsFormatted}/mo`}
                        icon="fruitful"
                        iconColor="blue"
                    />

                    <BodyLargeRegular
                        style={{
                            fontFamily: FontFamilyName.SourceSerifRegular,
                        }}
                    >
                        Your income lands in Core first — bills and spending are
                        funded before anything else, then the rest flows to your
                        goals.
                    </BodyLargeRegular>
                    <BodyLargeRegular
                        style={{
                            fontFamily: FontFamilyName.SourceSerifRegular,
                        }}
                    >
                        Point your recurring payments at your Core account or
                        virtual card and they&apos;re paid automatically each
                        month — nothing to remember.
                    </BodyLargeRegular>
                    <BodyLargeRegular
                        style={{
                            fontFamily: FontFamilyName.SourceSerifRegular,
                        }}
                    >
                        It&apos;s a secured charge card, so debt isn&apos;t
                        possible. The money you spend stays reserved and earning
                        interest until Fruitful pays the balance at month&apos;s
                        end.
                    </BodyLargeRegular>
                    <SlideNextButton />
                </YStack>
            </LinearGradientBackgroundCard>
            <BankingDisclosures color="$black" includeCard={false} />
        </YStack>
    );
};

export default BillsSlide;
